<template>
  <!-- 도메인 상태 pill — 상태값이면 색 pill, 아니면 평문 (SettlementStatusBadge variant 체계 계승) -->
  <span v-if="pill" class="ab-pill" :class="`ab-pill--${pill.variant}`">
    <span class="ab-pill__dot"></span>{{ pill.label }}
  </span>
  <span v-else>{{ text }}</span>
</template>

<script>
import { resolveStatusPill } from './useStatusPill'

/**
 * @component StatusPill
 * @description 어시스턴트 블록(표 셀/카드 필드)의 상태값 시각화.
 *   접수 8 + 정산 9 + 상담 4 상태를 variant 색(variables.css 토큰)으로 렌더.
 */
export default {
  name: 'StatusPill',
  props: {
    value: { type: [String, Number], default: '' }
  },
  computed: {
    pill() { return resolveStatusPill(this.value) },
    text() { return this.value == null ? '' : String(this.value) }
  }
}
</script>

<style scoped>
.ab-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: var(--radius-full, 9999px);
  padding: 2px 8px;
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.4;
  letter-spacing: 0.02em;
}
.ab-pill__dot { width: 5px; height: 5px; border-radius: 50%; background: currentColor; flex-shrink: 0; }
.ab-pill--info { background: var(--color-info-light, #DAE4F2); color: var(--color-info, #3670B3); }
.ab-pill--success { background: var(--color-success-light, #D4E9DF); color: var(--color-success, #2E7D5B); }
.ab-pill--warning { background: var(--color-warning-light, #F5EDDA); color: var(--color-warning, #C8870A); }
.ab-pill--danger { background: var(--color-danger-light, #F2DCDC); color: var(--color-danger, #C03A3A); }
.ab-pill--purple { background: var(--color-purple-light, #E4E0F0); color: var(--color-purple, #6B5CA5); }
.ab-pill--primary { background: var(--color-primary-50, #E8EDF4); color: var(--color-primary-600, #2C4578); }
.ab-pill--gray { background: var(--color-gray-100, #E8EAED); color: var(--color-gray-500, #5C616B); }
</style>
